var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataSortingAlphabeticalAscending = function SvgDataSortingAlphabeticalAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 2 4 10h2l.365-1h2.266L9 10h2L8.2 2H6.8ZM16 2v16h-3l4 4 4-4h-3V2h-2ZM7.547 5.264 8.067 7H6.933l.613-1.736ZM4 13v2h4l-4 4.563V21h7v-2H7l4-4.58V13H4Z"
  })));
};
export default SvgDataSortingAlphabeticalAscending;